export default __webpack_public_path__ + "static/media/online.be2a83fa.svg";